var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLogo)?_c('img',{staticClass:"liqpay-mark",attrs:{"src":_vm.isDarkSurface ? _vm.whiteLogo : _vm.colorLogo,"alt":"LiqPay"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }